export default __webpack_public_path__ + "static/media/(41).8eb2bd8b.jpg";